import { render, staticRenderFns } from "./GradeSelect.vue?vue&type=template&id=58afd2b1"
import script from "./GradeSelect.vue?vue&type=script&lang=js"
export * from "./GradeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports